<template>
  <div class="Air">
    <div class="header" v-if="item.showTitle">
      <div class="header_title">空气检测</div>
    </div>
    <div class="air_content">
      <div class="label">
        <span>{{item.data.site_name}}</span>
        <i class="iconfont icon-qiehuanchengshi" @click="checkSite" v-if="this.siteList.length > 1"></i>
      </div>
      <div class="air_info" :class="[item.data.data ? quality_info[item.data.data.quality_info.level].border : 'border_gray']">
        <div class="text">PM2.5</div>
        <div class="num" :class="item.data.data ? [quality_info[item.data.data.quality_info.level].color] : 'gray'">{{item.data.data ? item.data.data.pm25 : '未知'}}</div>
        <div class="text">ug/m³</div>
        <div :class="item.data.data ? quality_info[item.data.data.quality_info.level].bg :'bg_gray'">{{item.data.data ? item.data.data.quality_info.label : '暂未连接'}}</div>
      </div>
      <div class="air_list">
        <div class="list">
          <div class="name">甲醛</div>
          <div class="num" :class="[item.data.data ? 'blue' : 'gray']">{{item.data.data ? item.data.data.tvoc : '未知'}}</div>
          <div class="text">mg/m³</div>
        </div>
        <div class="list">
          <div class="name">温度</div>
          <div class="num" :class="[item.data.data ? 'blue' : 'gray']">{{item.data.data ? item.data.data.temperature : '未知'}}</div>
          <div class="text">℃</div>
        </div>
        <div class="list">
          <div class="name">湿度</div>
          <div class="num" :class="[item.data.data ? 'blue' : 'gray']">{{item.data.data ? item.data.data.humidity : '未知'}}</div>
          <div class="text">%</div>
        </div>
        <div class="list">
          <div class="name">二氧化碳</div>
          <div class="num" :class="[item.data.data ? 'blue' : 'gray']">{{item.data.data ? item.data.data.co2 : '未知'}}</div>
          <div class="text">PPM</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "Air",
    props:['item'],
    created() {
      this.siteList = this.item.filterList.filter(item => {
        return item.is_show == 1
      })
    },
    data() {
      return {
        loading: false,
        isSite: false,
        siteList: [
        ],
        quality_info:{
          1: {
            bg: 'bg_blue',
            border: 'border_blue',
            color: 'blue'
          },
          2: {
            bg: 'bg_blue',
            border: 'border_blue',
            color: 'blue'
          },
          3: {
            bg: 'bg_yellow',
            border: 'border_yellow',
            color: 'yellow'
          },
          4: {
            bg: 'bg_yellow',
            border: 'border_yellow',
            color: 'yellow'
          },
          5: {
            bg: 'bg_red',
            border: 'border_red',
            color: 'red'
          },
          6: {
            bg: 'bg_red',
            border: 'border_red',
            color: 'red'
          },
        }
      }
    },
    methods: {
      checkSite(){
        let index
        console.log(this.item.data)
        for(let i in this.siteList){
          if(this.siteList[i].id == this.item.data.id){
            if(i == this.siteList.length -1){
              index = 0
            }else{
              index = Number(i) + 1
            }
          }
        }
        let data = {
          id: this.siteList[index].id,
          org_id: this.orgId
        }
        this.$ajax('/Home/TinyWebsite/airData', data, 'GET').then((res) => {
          console.log(res)
          this.loading = false
          if(res.code == 200){
            this.item.data =  res.data
          }
        })
        
        this.isSite = false
      }
    },
    computed:{
      ...mapState({
        orgId:state=>state.orgId
      })
    }
  }
</script>

<style lang="less" scoped>
.Air{
  padding: 10px;
  font-size: 14px;
  .header{
  	display: flex;
  	align-items: center;
  	justify-content: space-between;
  	margin: 10px 0;
  	.header_title{
  		font-size: 16px;
  		font-weight: 800;
  	}
  }
  .air_content{
    width: 100%;
    .label{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #666;
      .iconfont{
        font-size: 16px;
        margin-left: 3px;
      }
    }
    .air_info{
      border: 2px solid;
      border-radius: 50%;
      width: 200px;
      height: 200px;
      margin: 0 auto 10px;
      text-align: center;
      padding: 30px;
      .text{
        color: #999;
        margin-bottom: 15px;
      }
      .num{
        font-size: 20px;
        font-weight: 600;
        margin: 15px 0;
      }
    }
      
    .air_list{
      display: flex;
      justify-content: space-around;
      .list{
        font-size: 14px;
        text-align: center;
        line-height: 24px;
        .text{
          color: #999;
        }
      }
    }
  }
  .blue{
    color: #03a9f4;
  }
  .yellow{
    color: #F59A23;
  }
  .red{
    color: #C31B39;
  }
  .gray{
    color: #999 !important;
  }
  .border_blue{
    border-color: #03a9f4 !important;
  }
  .border_yellow{
    border-color: #F59A23 !important;
  }
  .border_red{
    border-color: #C31B39 !important;
  }
  .border_gray{
    border-color: #999 !important;
  }
  .bg_blue{
    display: inline-block;
    color: #fff;
    background: #03a9f4;
    border-radius: 3px;
    padding: 4px 5px;
  }
  .bg_yellow{
    display: inline-block;
    color: #fff;
    background: #F59A23;
    border-radius: 3px;
    padding: 4px 5px;
  }
  .bg_red{
    display: inline-block;
    color: #fff;
    background: #C31B39;
    border-radius: 3px;
    padding: 4px 5px;
  }
  .bg_gray{
    display: inline-block;
    color: #fff;
    background: #999;
    border-radius: 3px;
    padding: 4px 5px;
  }
}
  
</style>
